import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const AddDaysButton = props => {
  return (
    <ResponsiveButton to='/plans/cart' color='secondary' {...props}>
      Add Days
    </ResponsiveButton>
  )
}

export default AddDaysButton
